import React from "react";
import Nav from "react-bootstrap/Nav";

import { NavDropdown } from "react-bootstrap";
import HISDSEAL from "../images/HISDSEAL.png";
import Image from "react-bootstrap/Image";
import AskIT from "../images/AskIT.png";
import { Button, Navbar, Form, Row, Col } from "react-bootstrap";

import { useState, useContext } from "react";
import { useNavigate } from "react-router";
import { GearFill } from "react-bootstrap-icons";
import { useSelector } from "react-redux";

const NavbarMain = () => {
  /*
  const userRole = useSelector((state) => state.userProps.user.role);
  const loginId = useSelector((state) => state.userProps.user.loginId);
*/

  const loginId = useSelector((state) => state.userProps.loginId); 
  // 2. Get the roles array (plural) directly from userProps
  const userRole = useSelector((state) => state.userProps.role);

  //const fullname = loginId;
   const _Campus = useSelector(
    (state) => state.userProps.campusName,
  );
  
  
  const fullname =
    "Hello: " + useSelector((state) => state.userProps.loginId  + " - " + state.userProps.campusName);
  
 

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const navigate = useNavigate();
  var loginName = "User: " + loginId;

  const goToAdmin = () => {
    navigate("/SystemMessage");
  };

  return (
    <>
      <div id="MasterContainer" style={{ backgroundColor: "#24383C" }}>
        <Navbar expand="lg">
          <Navbar.Brand
            href="#"
            style={{
              fontWeight: "bold",
              color: "white",
              fontSize: "2em",
              marginLeft: "50px",
            }}
          >
            <Image
              src={HISDSEAL}
              fluid
              roundedCircle
              style={{ width: "100px", height: "100px" }}
              marginRight="1"
            />
          </Navbar.Brand>

          <Navbar.Collapse>
            <Button
              href="https://houstonisd.sharepoint.com/SolutionCenter/SitePages/HISD-Solution-Center.aspx"
              target="_blank"
              rel="noopener noreferrer"
              variant="success"
              //className="btn-raised"
              style={{
                marginRight: "5px",
                backgroundColor: "#006F5B",
                marginLeft: "25px",
                width: "150px",
              }}
            >
              Solution Center
            </Button>

            <Button
              href="https://houstonisd.sharepoint.com/SolutionCenter/_layouts/15/stream.aspx?id=%2FSolutionCenter%2FAskIT%2FIntroducing%20AskIT%2Emp4&nav=eyJwbGF5YmFja09wdGlvbnMiOnsic3RhcnRUaW1lSW5TZWNvbmRzIjoyLjU5NzUxNn19&referrer=StreamWebApp%2EWeb&referrerScenario=AddressBarCopied%2Eview%2E01bf7f9a%2Dbfc0%2D42db%2D8ada%2D2ff6fbadb1c5"
              target="_blank"
              rel="noopener noreferrer"
              variant="success"
              //className="btn-raised"
              style={{
                marginRight: "5px",
                backgroundColor: "#006F5B",
                width: "150px",
              }}
            >
              Overview Video
            </Button>

            <Button
              href="https://houstonisd.sharepoint.com/SolutionCenter/AskIT/Forms/AllItems.aspx?id=%2FSolutionCenter%2FAskIT%2FAskIT%5FQRG%202025%2Epdf%2Epdf&parent=%2FSolutionCenter%2FAskIT"
              target="_blank"
              rel="noopener noreferrer"
              variant="success"
              //className="btn-raised"
              style={{
                marginRight: "5px",
                backgroundColor: "#006F5B",
                width: "150px",
              }}
            >
              Quick Guide
            </Button>

            <Button
              href="https://houstonisd.sharepoint.com/:u:/t/ITDMG/EeBU9hY8prhNiIILexY2DfEBIjNm0KLALjvWZhq-TC7Gww?e=TkKucG"
              target="_blank"
              rel="noopener noreferrer"
              variant="success"
              //className="btn-raised"
              style={{
                marginRight: "5px",
                backgroundColor: "#006F5B",
                width: "250px",
              }}
            >
              Device Management Guide
            </Button>
          </Navbar.Collapse>

          <Form inline="true">
            <Row style={{ fontWeight: "bold", color: "white" }}>
              <Col>{fullname}</Col>
              <Col xs="auto" style={{ marginRight: "20px" }}>
                {userRole === "Admin" || userRole === "ASKIT_News" ? (
                  <GearFill onClick={(e) => goToAdmin()} />
                ) : (
                  <h1></h1>
                )}
              </Col>
            </Row>
          </Form>
        </Navbar>
      </div>
    </>
  );
};

const myStyles = {
  navBarMarginLeft: {
    marginLeft: "15px",
  },
};

export default NavbarMain;
